export const complexFilterBasePath = '/api/v1/complex-filter'
import api from './api'

export async function postComplexFilter(request) {
  const resp = await api.post(`${complexFilterBasePath}`, request)
  return resp.data
}

export async function listComplexFilters() {
  const resp = await api.get(`${complexFilterBasePath}`)
  return resp.data
}

export async function getComplexFilter(id) {
  const resp = await api.get(`${complexFilterBasePath}/${id}`)
  return resp.data
}

export async function patchComplexFilter(request, id) {
  const resp = await api.patch(`${complexFilterBasePath}/${id}`, request)
  return resp.data
}
